import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import makeStyles from '@material-ui/styles/makeStyles';
import * as React from 'react';

const useStyles = makeStyles({
  iconStyle: {
    fill: 'none',
    '&>path': {
      stroke: 'currentColor',
    },
  },
});

function FileIcon(props: SvgIconProps) {
  const classes = useStyles();
  return (
    <SvgIcon className={classes.iconStyle} {...props}>
      <path
        d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
        stroke="#000"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 2v6h6M16 13H8M16 17H8M10 9H8"
        stroke="#000"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

const MemoFileIcon = React.memo(FileIcon);
export default MemoFileIcon;
